const data = [
  {
    id: 1,
    name: "Tony Stark",
    age: 39,
    image:
      "https://i.pinimg.com/originals/5c/24/cf/5c24cfa588f156b2a2740b5a3d601a4f.jpg",
  },
  {
    id: 2,
    name: "Natasha Romanoff",
    age: 28,
    image:
      "https://i.pinimg.com/originals/ad/b4/5d/adb45d43146470559d51b128ae6a1846.jpg",
  },
  {
    id: 3,
    name: "Steve Rogers",
    age: 32,
    image:
      "https://i.pinimg.com/originals/6b/61/95/6b6195643be6cc09ef8c4d47d37dac11.jpg",
  },
  {
    id: 4,
    name: "Wanda Maximoff",
    age: 26,
    image:
      "https://i.pinimg.com/originals/84/98/ce/8498ce7be47c83b7dcd2c7926125bd24.jpg",
  },
  {
    id: 5,
    name: "Stephen Strange",
    age: 35,
    image:
      "https://i.pinimg.com/originals/5f/30/8d/5f308d8289c8d8c1003ce443719a7119.jpg",
  },
];


export default data;